<div class="thumb-xs" *ngIf="path != null && fileType == 'Image'">
  <ecpl-image-viewer
    [imgSrc]="path"
    [imgType]="path"
    [imgName]="filename"
    [id]="documentId"
    thumbNail="true"
  ></ecpl-image-viewer>
</div>

<div class="thumb-xs" *ngIf="path != null && fileType == 'Pdf'">
  <ecpl-pdf-viewer
    [id]="documentId"
    [pdfSrc]="path"
    [pdfName]="filename"
  ></ecpl-pdf-viewer>
</div>

<div class="thumb-xs" *ngIf="path != null && fileType == 'Document'">
  <ecpl-onlyoffice-viewer
    [onlyofficeSrc]="path"
    [onlyofficeType]="extension"
    [onlyofficeName]="filename"
    [onlyofficeMode]="false"
    [id]="documentId"
  ></ecpl-onlyoffice-viewer>
</div>

<div class="thumb-xs" *ngIf="fileType != 'Pdf' && fileType != 'Image' && fileType != 'Document'">
  <img
    src="../../../../assets/file-icons/kb-article.png"
    *ngIf="isArticle == true"
  />
  <img
    src="../../../../assets/file-icons/kb-file-ppt.png"
    *ngIf="(isArticle == false || isArticle == null) && (extension == 'ppt' || extension == 'pptx')"
  />
  <img
    src="../../../../assets/file-icons/kb-file-general.png"
    *ngIf="(isArticle == false || isArticle == null) && extension == 'txt'"
  />
  <img
    src="../../../../assets/file-icons/kb-article.png"
    *ngIf="documentType == 'article'"
  />
  <img
    src="../../../../assets/file-icons/kb-file-video.png"
    *ngIf="documentType == 'videos'"
  />
</div>
